import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../../styles/cr.module.scss';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { useParams } from 'react-router-dom';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { CrCommandBar } from '../cr/CrCommandBar';
import TaskStageContainer from './TaskStageContainer';
import { DataContext } from '../DataContext';
import { IApp03Task, IApp03Workflow, IApp03WorkflowStage } from '../../types';
import { TaskPriority, WorkflowType, getWorkflowTypeString } from '../../refData/WorkflowType';
import { OrbUserContext } from '../OrbUserContext';
import { Toggle } from '@fluentui/react';
import { CrLoadingOverlay } from '../cr/CrLoadingOverlay';
import { TaskShortForm } from './TaskShortForm';
import TaskStageContainerStudyPlanner from './TaskStageContainerStudyPlanner';
import { TaskFormPageStudyPlanner } from './TaskFormPageStudyPlanner';
import { TaskViewStudyPlanner } from './TaskViewStudyPlanner';

interface StudyPlannerTasksProps extends IWithErrorHandlingProps {
    apiConnected: boolean;
    lastPortfolioIdForChilds?: number | null;
    frameworkID: number;
}

export enum TaskFormType {
    ShortForm = "ShortForm",
    FullForm = "FullForm",
}

const StudyPlannerTasks = (props: StudyPlannerTasksProps) => {

    const { dataServices } = useContext(DataContext);
    const { userContext } = useContext(OrbUserContext);
    //const { workflowIdForTasks } = useParams<{ workflowIdForTasks: string }>();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [justMyTasks, setJustMyTasks] = useState<boolean>(false);
    const [showTaskForm, setShowTaskForm] = useState<TaskFormType>(null);
    //const [showTaskFullForm, setShowTaskFullForm] = useState<TaskFormType>(null);
    const [showTaskView, setShowTaskView] = useState(false);
    const [selectedTask, setSelectedTask] = useState<number>(null);
    const [showStageForm, setShowStageForm] = useState(false);
    const [editStage, setEditStage] = useState(false);
    const [selectedStageToEdit, setSelectedStageToEdit] = useState<number>(null);

    const [loadStageDataCount, setLoadStageDataCount] = useState(0);
    const [loadTasksListDataCounter, setLoadTasksListDataCounter] = useState(0);
    const [workflow, setWorkflow] = useState<IApp03Workflow>();
    const [tasksForCount, setTasksForCount] = useState<IApp03Task[]>();
    const [newTaskDefaultStageTitle, setNewTaskDefaultStageTitle] = useState<string>(null);

    const [taskSelectionPreservedOnEmptyClick, setTaskSelectionPreservedOnEmptyClick] = useState<boolean>(false);

    const commandBarItems: ICommandBarItemProps[] = [
        // {
        //     key: 'NewTask',
        //     text: 'New Task',
        //     iconProps: { iconName: 'Add' },
        //     onClick: (ev, item) => {
        //         handleAddNewTask();
        //     },
        // },
        (selectedTask !== null) && {
            key: 'EditTask',
            text: 'Edit Task',
            iconProps: { iconName: 'Edit' },
            onClick: (ev, item) => {
                setTaskSelectionPreservedOnEmptyClick(true);
                setShowTaskForm(TaskFormType.FullForm);
            },
        },
        (selectedTask !== null) && {
            key: 'View',
            text: 'View',
            iconProps: { iconName: 'View' },
            onClick: (ev, item) => {
                setShowTaskView(true);
            },
        },

    ].filter(Boolean);

    const handleAddNewTask = (defaultStageTitle?: string) => {
        setNewTaskDefaultStageTitle(defaultStageTitle);
        setSelectedTask(null);
        setShowTaskForm(TaskFormType.FullForm);
    }

    const showTaskViewToggle = () => {
        setShowTaskView(!showTaskView);
    }

    useEffect(() => {
        if (showTaskForm === TaskFormType.FullForm) {
            const scrollableParent = document.querySelector('#TaskFormPageContainer');
            console.log('Scrollable Parent:', scrollableParent);
            scrollableParent?.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [showTaskForm]);


    useEffect(() => {
        const fetchWorkflow = async () => {
            setIsLoading(true);
            try {
                const workflow: IApp03Workflow = await dataServices.app03WorkflowService.readFirstStudyPlannerWorkflow();
                if (workflow !== null) {
                    const tasks = await dataServices.app03TaskService.countTasksForStudyPlannerStudent(userContext.UserId);
                    console.log('tasks', tasks);
                    setTasksForCount(tasks);
                    setWorkflow(workflow);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            finally {
                setIsLoading(false);
            }

        };

        fetchWorkflow();
    }, [loadStageDataCount, loadTasksListDataCounter]);

    const onSaveStage = (): void => {
        setLoadStageDataCount(loadStageDataCount + 1);
    }

    // const handleEditStageSelection = (stageID: number): void => {
    //     setSelectedStageToEdit(stageID);
    // }

    const handleChangeSelectedTask = (taskID: number, showTaskForm?: TaskFormType) => {
        console.log('in handleChangeSelectedTask', taskID, showTaskForm);
        setSelectedTask(taskID);
        if (showTaskForm) {
            if (showTaskForm === TaskFormType.FullForm) {
                //user clicks on blue task title to open full form in edit mode
                setShowTaskForm(TaskFormType.FullForm);
                setTaskSelectionPreservedOnEmptyClick(true);
            }
            else {
                setShowTaskForm(TaskFormType.ShortForm);
            }
        }
        else {
            setShowTaskForm(null);
        }
    };

    // const showStageFormToggle = () => {
    //     setShowStageForm(!showStageForm);
    // }

    const taskFormSharedProps = {
        showForm: true,
        workflowID: workflow?.ID,
        newTaskStageID: null,
        //newTaskStageTitle: newTaskDefaultStageTitle || null,
        entityId: selectedTask,
        onSaved: () => {
            setTaskSelectionPreservedOnEmptyClick(false);
            setShowTaskForm(null);
            setLoadTasksListDataCounter(loadTasksListDataCounter + 1);
        },
        onCancelled: () => {
            setTaskSelectionPreservedOnEmptyClick(false);
            setShowTaskForm(null);
        },
        ...props,
    };

    return (
        <div className={`${styles.cr} ${styles.updatesContainer}`} style={{ width: '100%' }}>
            {
                workflow &&
                showTaskForm &&
                showTaskForm === TaskFormType.FullForm &&
                <div id='TaskFormPageContainer'>
                    <TaskFormPageStudyPlanner
                        frameworkID={props.frameworkID}
                        workflowTitle={workflow.Title}
                        {...taskFormSharedProps} />
                </div>

            }

            {
                <div style={{ display: (showTaskForm === TaskFormType.FullForm) ? 'none' : 'block' }}>
                    <CrLoadingOverlay isLoading={isLoading} opaque={true} />
                    <CrCommandBar items={commandBarItems} />
                    {/* {
                        showStageForm &&
                        <WFStageForm
                            workflowID={Number(workflowIdForTasks)}
                            editRequest={editStage}
                            showForm={showStageForm}
                            onEditStageSelection={handleEditStageSelection}
                            entityId={selectedStageToEdit}
                            {...props}
                            onSaved={() => {
                                onSaveStage();
                                showStageFormToggle();
                            }}
                            onCancelled={showStageFormToggle}
                            {...props}
                        />
                    } */}
                    <div>
                        <div className='tasks-header' style={{ borderBottom: 'none' }}>
                            <div className='tasks-info'>
                                <div>
                                    <h2 className={styles.listTitle}>Study Planner Tasks for {userContext.UserTitle}</h2>
                                    {/* <div style={{ fontStyle: 'italic', paddingLeft: '10px', paddingBottom: '10px' }}>{workflow && getWorkflowTypeString(workflow.WorkflowTypeID)} workflow</div> */}
                                </div>
                            </div>
                            {/* <div className="tasks-toggle">
                                <Toggle
                                    onText={`Just my tasks`}
                                    offText={`Just my tasks`}
                                    checked={justMyTasks}
                                    onChange={() => {
                                        setJustMyTasks(!justMyTasks);
                                        setLoadTasksListDataCounter(loadTasksListDataCounter + 1);
                                    }}
                                />
                            </div> */}
                        </div>

                        {tasksForCount && workflow && workflow?.App03WorkflowStages?.map((stage, index) => (
                            <TaskStageContainerStudyPlanner
                                key={index}
                                //workflowID={workflow.ID}
                                stageTitle={stage?.Title}
                                //counts={workflow.App03Tasks?.filter(t => t.WorkflowStageID === stage.ID && t.Archived !== true).length ?? 0}
                                counts={tasksForCount?.filter(t => t.WorkflowStage?.Title === stage?.Title && t.Archived !== true).length ?? 0}
                                //totalCritical={workflow.App03Tasks?.filter(t => t.WorkflowStageID === stage.ID && t.TaskPriorityID === TaskPriority.Critical && t.Archived !== true).length ?? 0}
                                //totalUserCritical={workflow.App03Tasks?.filter(t => t.WorkflowStageID === stage.ID && t.TaskPriorityID === TaskPriority.Critical && t.App03TaskUsers.some(user => user.UserID === userContext.UserId)).length ?? 0}
                                archived={null}
                                userIDFilter={userContext.UserId}
                                onSaveData={onSaveStage}
                                onChangeSelectedTask={handleChangeSelectedTask}
                                loadTasksListDataCounter={loadTasksListDataCounter}
                                clearSelection={selectedTask === null}
                                //onNewTaskClick={handleAddNewTask}
                                taskSelectionPreservedOnEmptyClick={taskSelectionPreservedOnEmptyClick}
                                {...props}
                            />
                        ))}

                        {/* for archived */}
                        {workflow &&
                            <TaskStageContainerStudyPlanner
                                //workflowID={workflow.ID}
                                stageTitle={null}
                                archived={true}
                                userIDFilter={userContext.UserId}
                                //counts={workflow.App03Tasks?.filter(t => t.Archived === true).length ?? 0}
                                counts={tasksForCount?.filter(t => t.Archived === true).length ?? 0}
                                onSaveData={onSaveStage}
                                onChangeSelectedTask={handleChangeSelectedTask}
                                loadTasksListDataCounter={loadTasksListDataCounter}
                                clearSelection={selectedTask === null}
                                taskSelectionPreservedOnEmptyClick={taskSelectionPreservedOnEmptyClick}
                                {...props}
                            />
                        }

                        {
                            workflow && showTaskForm == TaskFormType.ShortForm &&
                            <TaskShortForm {...taskFormSharedProps} />
                        }

                        {
                            workflow && showTaskView &&
                            <TaskViewStudyPlanner
                                showForm={showTaskView}
                                entityId={selectedTask}
                                entityName='Task'
                                onClosed={showTaskViewToggle}
                                loadEntity={() => dataServices.app03TaskService.readForViewStudyPlanner(selectedTask)}
                            />
                        }

                    </div>
                </div>
            }



        </div>

    );
};

export default withErrorHandling(StudyPlannerTasks);